module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-4"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.left) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "color": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.left.length)
    }
  }), _vm._v(" "), (_vm.left.length > 0) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.left), function(item, index) {
    return [_c('generic-list-item', {
      key: item.id,
      attrs: {
        "with-id": "",
        "item-title": _vm.itemTitle,
        "item-sub-title": _vm.itemSubTitle
      },
      model: {
        value: (_vm.left[index]),
        callback: function($$v) {
          _vm.$set(_vm.left, index, $$v)
        },
        expression: "left[index]"
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (item.id))
    })]
  })], 2) : _c('v-subheader', {
    staticClass: "pa-3"
  }, [_vm._v("No items to merge")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.right) ? _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "color": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.right.length)
    }
  }), _vm._v(" "), (_vm.right.length > 0) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.right), function(item, index) {
    return [_c('generic-list-item', {
      key: item.id,
      attrs: {
        "with-id": "",
        "item-title": _vm.itemTitle,
        "item-sub-title": _vm.itemSubTitle
      },
      model: {
        value: (_vm.right[index]),
        callback: function($$v) {
          _vm.$set(_vm.right, index, $$v)
        },
        expression: "right[index]"
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "action"
      },
      slot: "action"
    }, [_c('v-checkbox', {
      attrs: {
        "value": item.id
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (item.id))
    })]
  })], 2) : _c('v-subheader', {
    staticClass: "pa-3"
  }, [_vm._v("No items to merge")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.selected.length === 0,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("transfer", _vm.selected)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")]), _vm._v("\n            Transfer " + _vm._s(_vm.selected.length) + " items\n          ")], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ede166","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/merge/ArrayMergePreview.vue
// module id = 1647
// module chunks = 2